/**
 * Partnership values — exact strings from the /me contract.
 */
export const PARTNERSHIPS = {
  SellerCentral: "SELLER_CENTRAL",
  VendorCentral: "VENDOR_CENTRAL",
} as const satisfies Record<string, string>;

export type Partnership = typeof PARTNERSHIPS[keyof typeof PARTNERSHIPS];

export const PARTNERSHIP_LABELS = {
  [PARTNERSHIPS.SellerCentral]: "Seller Central",
  [PARTNERSHIPS.VendorCentral]: "Vendor Central",
} as const satisfies Record<Partnership, string>;

/**
 * Short aliases used in route meta (`meta.partnerships`).
 * A route without the field is seller-only by convention.
 */
export type PartnershipAlias = "seller" | "vendor";

export const PARTNERSHIP_BY_ALIAS = {
  seller: PARTNERSHIPS.SellerCentral,
  vendor: PARTNERSHIPS.VendorCentral,
} as const satisfies Record<PartnershipAlias, Partnership>;

/**
 * Vendor from GET /vendors — keys mirror the backend payload as-is.
 */
export interface Vendor {
  VENDOR_PK: number
  BK_VENDOR_ID: number
  VENDOR_NAME: string
  SHORT_NAME: string
}

/**
 * Vendor brand from GET /vendor-brands — keys mirror the backend payload as-is.
 */
export interface VendorBrand {
  VENDOR_BRAND_PK: number
  VENDOR_PK: number
  VENDOR_NAME: string
  BRAND_NAME: string
  BRAND_SHORT_NAME: string
  IS_ACTIVE: boolean
}

/**
 * Vendor brand group from GET /vendor-brands/groups — keys mirror the backend payload as-is.
 * Structurally identical to the seller brand group. Brands inside a group link to
 * /vendor-brands by BRAND_SHORT_NAME (VendorBrand has no BK_BRAND_ID business key).
 */
export interface VendorBrandGroup {
  BRAND_GROUPS_ID: number
  BRAND_GROUPS_SHORT_NAME: string
  PARENT_BRAND_NAME: string
  BRANDS: Array<{
    BRAND_ID: string
    BRAND_NAME: string
    BRAND_SHORT_NAME: string
  }>
}

/**
 * Vendor product from POST /vendor-products — keys mirror the backend payload as-is.
 */
export interface VendorProduct {
  VENDOR_PRODUCT_PK: number
  VENDOR_PK: number
  VENDOR_NAME: string
  VENDOR_BRAND_PK: number
  BRAND_NAME: string
  BRAND_SHORT_NAME: string
  ASIN: string
  PRODUCT_NAME: string
}
